import React from 'react'

import Icon from './icon'

export default function Badge({
  text = 'BETA',
  className = 'badge-beta',
  icon = undefined,
}) {
  return (
    <span className={`badge ${className}`}>
      {icon && <Icon name={icon} className="me-1" />}
      {text}
    </span>
  )
}
